module.exports = __webpack_public_path__ + "img/home-disclaimer.2e17f818.png";